module.exports = __webpack_public_path__ + "img/首页海报2.db0c785d.png";